import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { IconArrowDown } from '../../assets/icon';
import { setYear } from '../../utils/compatibilityHelper';

const Accordion = ({
 data, styleContainer, arrowIcon, bordered, activeIndex
}) => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(activeIndex || -1);
  const {
    vehicleCompatibilityList
  } = useSelector((state) => ({
    vehicleCompatibilityList: state?.vehicleCompatibilityList.data
  }), shallowEqual);
  const onOpen = (index) => setActive(index === active ? -1 : index);
  return (
    <div className={`${styleContainer}`}>
      {data.map(({
 title, content, make, model, year
}, index) => (
  <div
    className={`${bordered ? 'border border-[#F4F4F4] dark:border-[#1b263b] border-t-0' : ''}
    ${bordered && index === 0 ? 'rounded-t-[6px] border-t border-[#F4F4F4] dark:border-[#1b263b]' : ''}
    ${bordered && index === data.length - 1 ? 'rounded-b-[6px]' : ''}`}
    key={title}
  >
    <div
      className={`flex flex-row items-center justify-between cursor-pointer p-[20px]
            ${bordered ? 'border-b border-[#F4F4F4] dark:border-[#1b263b]' : ''}`}
      role="presentation"
      onClick={() => onOpen(index)}
    >
      <div className="font-normal text-[16px]">{title}</div>
      <div className="flex flex-row gap-[10px]">
        <span
          role="presentation"
          onClick={(e) => {
            e.stopPropagation();
            setYear('', {
              option: {
                make,
                model,
                value: year
              }
            }, vehicleCompatibilityList, dispatch);
          }}
        >
          Sync
        </span>
        <div className={`flex transition-all duration-300 linear ${active === index ? 'rotate-0' : '-rotate-90'}`}>
          {arrowIcon || <IconArrowDown />}
        </div>
      </div>
    </div>
    <div
      className={`max-h-0 overflow-hidden ${active === index ? 'max-h-full' : ''}`}
    >
      <div className="p-[20px] text-[14px]">
        {content}
      </div>
    </div>
  </div>
      ))}
    </div>
  );
};

Accordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })).isRequired,
  styleContainer: PropTypes.string,
  arrowIcon: PropTypes.node,
  bordered: PropTypes.bool,
  activeIndex: PropTypes.number
};

Accordion.defaultProps = {
  styleContainer: '',
  arrowIcon: undefined,
  bordered: true,
  activeIndex: undefined
};

export default Accordion;
